import { render, staticRenderFns } from "./manage-alert-member.vue?vue&type=template&id=c4b3ab24&scoped=true"
import script from "./manage-alert-member.vue?vue&type=script&lang=js"
export * from "./manage-alert-member.vue?vue&type=script&lang=js"
import style0 from "./manage-alert-member.vue?vue&type=style&index=0&id=c4b3ab24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4b3ab24",
  null
  
)

export default component.exports